import React from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import axios from 'axios';
import { API_URL } from '../../../Services/ApiService';
import { showSuccessAlert, toastEmmit } from '../../../Helper/Toastr';
import { useState } from 'react';

export default function ForgotPassword() {
const [loader, setloader] = useState(false)

    const formik = useFormik({
        initialValues: {
          email: '',  
        },
        validationSchema: Yup.object({
          email: Yup.string()
            .email('Invalid email address')
            .required('Email is required'),
        }),
        onSubmit: (values) => { 
          console.log(values);
          setloader(true)
          axios.post(API_URL.Forget_Password,values).then(
            (res)=>{
                console.log(res)
                setloader(false)
                if(res?.data?.status === true){ 
                  resetForm()
                  document.getElementById('CloseForgModal').click()
                  showSuccessAlert(res?.data?.message)
                }
            },
            (err)=>{
                console.log(err?.response?.data?.message);
                toastEmmit("error", err?.response?.data?.message);
                setloader(false)
            }
           )
        },
      });

      function resetForm() {
        formik.resetForm();
      }

  return (
    <div>
       <div
          className="modal fade index"
          id="exampleModalone"
          tabIndex={-1}
          aria-labelledby="exampleModalLabelone"
          aria-hidden="true"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header border-0">
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  id='CloseForgModal'
                  aria-label="Close"
                  onClick={resetForm} 
                />
              </div>
              <div className="modal-body popup border-0 pb-50">
                <h4>RECOVER PASSWORD</h4>
                <p>Enter your email to recover your password</p>
                <form onSubmit={formik.handleSubmit} className="pt-10">
                  <div className="row justify-content-center">
                    <div className="col-xl-11 col-lg-11 col-md-12">
                      <div className="tp-register__input-box" style={{ marginBottom: 22 }}>
                        <label htmlFor="email">Email<sup className='error'>*</sup></label>
                        <input
                           id="email"
                           type="email"
                           placeholder="Enter Email Address"
                           name="email" // Connect input to the formik field
                           onChange={formik.handleChange} // Handle input change
                           onBlur={formik.handleBlur} // Handle input blur
                           value={formik.values.email}
                        />
                         {formik.touched.email && formik.errors.email && (
              <div className="error mt-1">{formik.errors.email}</div>
            )}
                      </div>
                    </div>
                    <div className="col-xl-11 col-lg-11 col-md-12 col-sm-12 mt-20">
                      <button
                        className={`tp-btn-lg  large head tp-contact-4__btn tp-btn-square w-100 popup ${loader?'disabled':""}`}
                        type="submit"
                      >
                        {loader && <span><i class="fa fa-spinner fa-spin fa-fw"></i></span>}
                       {loader?"": 'RECOVER'}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
    </div>
  )
}
